import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../../_services/langhfre.service';

@Component({
  selector: 'app-ask-trinka',
  templateUrl: './ask-trinka.component.html',
  styleUrls: ['./ask-trinka.component.scss']
})
export class AskTrinkaComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService
  ) { }

  ngOnInit() {
      this.titleService.setTitle("發揮生成式 AI 的寫作魔力｜Trinka 智慧寫作助手");
      this.metaTagService.updateTag({ name: 'description', content: "從零開始、延伸靈感，或接續未完成的段落──只要一句話，Trinka 就能協助你完成每一步。" });
      this.metaTagService.updateTag({ property: 'og:title', content: '發揮生成式 AI 的寫作魔力｜Trinka 智慧寫作助手' });
      this.metaTagService.updateTag({ property: 'og:description', content: "從零開始、延伸靈感，或接續未完成的段落──只要一句話，Trinka 就能協助你完成每一步。" });
      this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/features/tw/ai-studio/ai-assisted-writing' });
      this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
      this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
      this.metaTagService.updateTag({ name: 'twitter:title', content: '發揮生成式 AI 的寫作魔力｜Trinka 智慧寫作助手' });
      this.metaTagService.updateTag({ name: 'twitter:description', content: "從零開始、延伸靈感，或接續未完成的段落──只要一句話，Trinka 就能協助你完成每一步。" });
      this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://trinka.ai/assets/images/Trinka.jpg' });
      this.metaTagService.updateTag({ name: 'keywords', content: '' });
      this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
      this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/features/ai-studio/ai-assisted-writing' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features/ai-studio/ai-assisted-writing' });
      
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  stopAllVideos() {
    const iframes = Array.from(document.querySelectorAll('iframe.youtubeVideoForTryDemo'));
    iframes.forEach((iframe) => {
        const htmlIframe = iframe as HTMLIFrameElement;
        htmlIframe.src = htmlIframe.src;
    });
  }

  aiShowTab = 1;
  assistedWriting(index: number) {
    this.aiShowTab = index;
  }
}
